export default "__VITE_ASSET__BWPF0Xxt__"